<div class="tax-benefit-wrapper" [ngStyle]="{'top': top, 'left': left}">
  <a class="auto-shining" href="javascript:;">
    <img loading="lazy" data-src="/assets/images/Tax-benefit.png" matTooltip="80G Tax Exemption Certificate Available" width="103" height="30" alt="Tax Benefit" />
  </a>
</div>